<template>
  <span :class="className">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'base',
      validator: function(value) {
        return ['base', 'sm', 'lg', 'xl', '6xl'].indexOf(value) !== -1
      }
    },
    block: {
      type: Boolean,
      default: false
    },
    semi: {
      type: Boolean,
      default: false
    },
    bold: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'inherit',
      validator: function(value) {
        return (
          [
            'inherit',
            'body',
            'body-light',
            'primary',
            'secondary',
            'white'
          ].indexOf(value) !== -1
        )
      }
    }
  },
  computed: {
    className() {
      return `textline textline--${this.color} textline--${this.size} ${(this
        .semi &&
        'textline--semibold') ||
        ''} ${(this.bold && 'textline--bold') || ''} ${(this.block &&
        'textline--block') ||
        ''} ${(this.inverted && 'textline--inverted') || ''}`
    }
  }
}
</script>

<style lang="postcss">
.textline {
  @apply font-sans font-normal;
}
.textline--semibold {
  @apply font-semibold;
}
.textline--bold {
  @apply font-bold;
}
.textline--block {
  @apply block;
}
.textline--base {
  @apply text-base;
}
.textline--sm {
  @apply text-sm tracking-wide;
}
.textline--lg {
  @apply text-lg;
}
.textline--xl {
  @apply text-xl;
}
.textline--6xl {
  @apply text-6xl;
}
.textline-imherit {
  color: inherit;
}
.textline-body-light {
  @apply text-body-light;
}
.textline--primary {
  @apply text-primary;
}
.textline--secondary {
  @apply text-secondary;
}
.textline--white {
  @apply text-white;
}
</style>